import { useTranslation, t } from '../../../shared/i18n';
import React from 'react';
import { Space, Typography } from 'antd';
import ProductPlans from '../../components/ProductPlans';

const { Text } = Typography;

// 2026-10-07：套餐/价格/配额改为读取 /products（products.features 即后端执行配额），不再硬编码。
const PRECISION = { country: '国家级', province: '省级', city: '城市级', isp: '运营商级' };

const FEATURES = [
    { key: 'shared_resources_limit', label: '可绑定区域', unit: '个' },
    { key: 'dns_records_per_zone_limit', label: '每区域记录数', unit: '条' },
    { key: 'dns_cidr_per_zone_limit', label: 'CIDR 规则', unit: '条' },
    { key: 'dns_qps_limit', label: 'QPS 上限', unit: '次/秒' },
    { key: 'dns_resolution_precision', label: '解析精度', format: (v) => t(PRECISION[v] || v) },
    { key: 'dns_qos_level', label: 'QoS 等级', format: (v) => `Level ${v}` },
    { key: 'dns_dnssec', label: 'DNSSEC' },
    { key: 'dns_anycast', label: 'Anycast 加速' },
];


const DnsPlans = () => {
    const { t } = useTranslation();
    return (
        <>
            <ProductPlans
                productType="dns"
                resourceParam="zone_id"
                resourceLabel={t('Zone')}
                resourceListPath="/dns/zones"
                title={t('DNS plans')}
                subtitle={t('Smart DNS plans billed per zone')}
                featureDefs={FEATURES.map(f => ({
                    ...f,
                    label: t(f.label),
                    ...(f.unit ? { unit: t(f.unit) } : {}),
                    ...(f.key === 'dns_resolution_precision' ? { format: (v) => PRECISION[v] ? t(PRECISION[v]) : v } : {}),
                }))}
                notes={
                    <Space direction="vertical" size={4}>
                        <Text><Text strong>{t('Records per zone:')}</Text>{t('Number of DNS records allowed per DNS zone')}</Text>
                        <Text><Text strong>{t('CIDR rules:')}</Text>{t('Number of smart DNS rules based on IP ranges')}</Text>
                        <Text><Text strong>{t('Resolution granularity:')}</Text>{t('Geographic and ISP granularity supported by smart DNS')}</Text>
                        <Text><Text strong>{t('DNSSEC:')}</Text>{t('Domain Name System Security Extensions help prevent DNS hijacking and cache poisoning')}</Text>
                    </Space>
                }
            />
        </>
    );
};

export default DnsPlans;
